module.exports = __webpack_public_path__ + "static/media/15Bar.b93a2290.svg";